import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file Card.tsx
 * @author markJia(markjia@tencent.com)
 */
import React, { Fragment } from 'react';
import { useRefCallback } from '@tencent/glue-react-use';
import { ReplaceTrigger } from '../ReplaceTrigger/ReplaceTrigger';
import { ViewTrigger } from '../Trigger/Trigger';
import { RemoveTrigger } from '../RemoveTrigger/RemoveTrigger';
import { Tooltip } from '../../../components/Tooltip';
import { UploadStatus } from '@tencent/glue-model-upload';
import { withViewComponent } from '../../../hoc/withViewComponent';
import { Add, DeleteOne, LoadingAnimate, ReplaceOne } from '@tencent/adp-icons-react';
export var TriggerType;

(function (TriggerType) {
  TriggerType["APPEND"] = "append";
  TriggerType["REPLACE"] = "replace";
})(TriggerType || (TriggerType = {}));

export var ViewCard = withViewComponent(function ($p, $s, $c, $a) {
  var text = $p.text,
      value = $p.value,
      trigger = $p.trigger,
      isReplaceable = $p.isReplaceable,
      isRemovable = $p.isRemovable,
      id = $p.id,
      _$p$status = $p.status,
      status = _$p$status === void 0 ? UploadStatus.DEFAULT : _$p$status,
      onReplace = $p.onReplace,
      onRemove = $p.onRemove,
      onClick = $p.onClick;
  var clickHandle = useRefCallback(onClick);
  var replaceHandle = useRefCallback(onReplace);
  var removeHandle = useRefCallback(onRemove); // 空态 可添加/替换文件

  var getEmptyNode = function getEmptyNode() {
    var emptyNode = React.createElement("span", {
      className: $c('empty'),
      onClick: clickHandle
    }, React.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, React.createElement(Add, {
      fill: "#AAAFBB",
      size: 24
    }), React.createElement("div", {
      className: $c('text')
    }, text || '上传图片')));

    if (trigger) {
      emptyNode = trigger === TriggerType.APPEND ? React.createElement(ViewTrigger, {
        className: $c('trigger'),
        children: emptyNode
      }) : React.createElement(ReplaceTrigger, {
        className: $c('trigger'),
        id: id,
        children: emptyNode
      });
    }

    return emptyNode;
  }; // 点击替换icon


  var getReplaceIcon = function getReplaceIcon() {
    var replaceNode = React.createElement(Tooltip, {
      placement: "top",
      trigger: "hover",
      hideDelay: 0,
      theme: "dark",
      popoverStyle: {
        fontSize: 10
      },
      getPopper: function getPopper() {
        return '替换';
      }
    }, React.createElement(ReplaceOne, {
      className: $c('replace-icon'),
      fill: "rgba(0, 0, 0, .75)",
      size: 24,
      onClick: replaceHandle
    }));

    if (isReplaceable && !onReplace) {
      replaceNode = React.createElement(ReplaceTrigger, {
        className: $c('trigger'),
        id: id,
        children: replaceNode
      });
    }

    return replaceNode;
  }; // 点击删除icon


  var getRemoveIcon = function getRemoveIcon() {
    var removeNode = React.createElement(Tooltip, {
      trigger: "hover",
      placement: "top",
      hideDelay: 0,
      theme: "dark",
      popoverStyle: {
        fontSize: 10
      },
      getPopper: function getPopper() {
        return '删除';
      }
    }, React.createElement(DeleteOne, {
      className: $c('remove-icon'),
      fill: "rgba(0, 0, 0, .75)",
      size: 24,
      onClick: removeHandle
    }));

    if (isRemovable && !onRemove) {
      removeNode = React.createElement(RemoveTrigger, {
        className: $c('trigger'),
        id: id,
        children: removeNode
      });
    }

    return removeNode;
  };

  var valueContent = React.createElement(Fragment, null, React.createElement("span", {
    className: $c('mask')
  }, React.createElement("span", {
    className: $c('control')
  }, isRemovable && getRemoveIcon(), isReplaceable && getReplaceIcon())), React.createElement("img", {
    className: $c('value'),
    src: value
  }));

  var getContent = function getContent() {
    var contentNode = getEmptyNode();

    switch (status) {
      case UploadStatus.DEFAULT:
        {
          contentNode = getEmptyNode();
          break;
        }

      case UploadStatus.UPLOADING:
        {
          contentNode = React.createElement(LoadingAnimate, {
            className: $c('content-loading'),
            fill: "#999",
            size: 32
          });
          break;
        }

      case UploadStatus.SUCCESS:
        {
          contentNode = valueContent;
          break;
        }
    }

    return contentNode;
  };

  return React.createElement("div", _objectSpread({
    className: $c(true, {
      success: value
    }, false),
    style: $s
  }, $a), React.createElement("div", {
    className: $c('content', undefined, false)
  }, getContent()));
}, 'upload-card', ['text', 'value', 'trigger', 'isReplaceable', 'isRemovable', 'id', 'status', 'onReplace', 'onRemove', 'onClick']);